import {NotificationCountType, Room} from 'matrix-js-sdk';
import {getLastMessage} from './get-last-message';
import getMetadata from './get-metadata';
import {TFunction} from 'i18next';
import {JoinedRoomData} from '@/redux-store/slices/matrix/room-data';
import {AppVariant, DocumentType} from '@/types/common';
import {getDocumentIdFromAlias} from './get-document-id-from-alias';
import {isSystemMessage} from '@/components/matrix-chat/utils/helper-functions';

import {SystemMessageAction} from '@/types/matrix';
import {getText} from '../messages';

export const extractJoinedRoomData = async (
  room: Room,
  t: TFunction
): Promise<JoinedRoomData> => {
  const {roomId} = room;
  const lastMessage = getLastMessage(room);
  const effectiveEvent = lastMessage?.getEffectiveEvent();
  let metadata = getMetadata(room) || {
    appVariant: AppVariant.SPORTJOE,
    documentType: DocumentType.P2P,
    topic: 'No topic'
  };
  let lastMessageFallback: JoinedRoomData['lastMessage'] | null = null;
  const myMembership = room.getMyMembership();
  if (myMembership === 'knock') {
    lastMessageFallback = {
      message: t(SystemMessageAction.Knocked),
      sender: room.client.getUserId() || 'unknown',
      senderName: 'unknown',
      system: true
    };
  } else if (myMembership === 'invite') {
    lastMessageFallback = {
      message: t(SystemMessageAction.Invited),
      sender: room.client.getUserId() || 'unknown',
      senderName: 'unknown',
      system: true
    };
  }
  const isDirect =
    lastMessageFallback || metadata.documentType === DocumentType.P2P
      ? true
      : false;

  if (isDirect) {
    const otherUser = room
      .getMembers()
      .find((m) => m.userId !== room.client.getUserId());
    if (otherUser) {
      const cleanName = otherUser.name.replace(/\s*\(@[^)]+\)/, '');
      metadata = {...metadata, topic: cleanName};
    }
  }

  const senderName = effectiveEvent?.content.displayname || 'unknown';

  return {
    roomId,
    documentId:
      getDocumentIdFromAlias(room.getCanonicalAlias() || 'unknown') ||
      'unknown',
    lastChange: room.getLastActiveTimestamp(),
    lastMessage: lastMessage
      ? {
          sender: lastMessage.getSender() || '',
          senderName: effectiveEvent?.content.displayname || 'unknown',
          message: getText(lastMessage, t, senderName, isDirect) || '',
          system: isSystemMessage(lastMessage)
        }
      : lastMessageFallback,
    metadata,
    isDirect,
    unread: room.getUnreadNotificationCount(NotificationCountType.Total)
  };
};
